import './Price.css';

import React from 'react';
import { Typography } from '@vtblife/uikit';
import { TypographyProps } from '@vtblife/uikit/dist/components/typography/types';

import { Currency } from '@search/filter-enums/enums/Currency';
import { RentPeriod } from '@search/filter-enums/enums/RentPeriod';
import { formatNumber } from '@search/helpers/src/formatNumber';
import classname from '@search/classname/src';

import { currencyMapping } from '@search/filter-enums/mappings/currency_mapping';
import { rentPeriodMapping } from '@search/filter-enums/mappings/rent_period_mapping';
import { getPriceForMicroLayout } from '../../../../domain/seo/getPriceForMicroLayout';
import { useToggleChain } from './popper/useToggleChain';
import { PriceHistoryMarker } from './PriceHistory/PriceHistoryMarker';
import { PriceHistoryPart } from './PriceHistory/PriceHistoryPart';

const cn = classname.bind(null, 'Price');

interface IProps extends TypographyProps {
    priceValue: number;
    priceCurrency?: Currency;
    rentPeriod?: RentPeriod;
    hasItemProp?: boolean;
    isMobile?: boolean;
    history?: readonly PriceHistoryPart[];
    hasHighlight?: boolean;
    renderSubscribeToPrice?: React.ReactNode;
}

export const PriceWithoutPopper: React.FC<IProps> = ({
    isMobile = false,
    hasHighlight = false,
    priceValue,
    rentPeriod,
    priceCurrency = Currency.RUB,
    hasItemProp,
    history,
    className,
    bold = true,
    variant = 'promo-subheader-alone',
    renderSubscribeToPrice,
    ...customTypographyProps
}) => {
    const rentPeriodEl = rentPeriod ? <>/{rentPeriodMapping[rentPeriod]}</> : undefined;

    const currency = (
        <span
            key='priceCurrency'
            itemProp='priceCurrency'
            // @ts-ignore
            content={getPriceForMicroLayout(priceCurrency)}
        >
            {currencyMapping[priceCurrency]}
        </span>
    );

    const number = (
        <span
            key='price'
            itemProp='price'
            // @ts-ignore
            content={priceValue}
            data-test='offer-price'
        >
            {formatNumber(priceValue)}
        </span>
    );

    const spy = useToggleChain({
        enterTimeout: isMobile ? 0 : 250,
        leaveTimeout: isMobile ? 0 : 250
    });

    const isHistory = history && history.length > 1;
    const current = history?.[0];
    const prev = history?.[1];
    const isUp = current && prev && current.valueRub > prev.valueRub;

    return (<>
        <div className={cn(null, { hasHistory: isHistory }, className)}>
            <Typography
                {...customTypographyProps}
                bold={bold}
                variant={variant}
                itemType='http://schema.org/Offer'
                itemProp={hasItemProp ? 'offers' : undefined}
                itemScope
                className={cn('typography', {
                    hasHighlight
                })}
            >
                {number}&nbsp;{currency}{rentPeriodEl}
            </Typography>
            {isHistory && <PriceHistoryMarker isUp={isUp} />}
        </div>
    </>);
};
